import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "left-arrow",
  "use": "left-arrow-usage",
  "viewBox": "0 0 38 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 23\" id=\"left-arrow\">\n  <g fill=\"none\" fill-rule=\"nonzero\">\n    <path fill=\"#2E2E2E\" d=\"M10.4 23l1.7-1.9-7.5-8.3H38v-2.6H4.6l7.5-8.3L10.4 0 0 11.5z\" />\n    <path d=\"M-4-12h47v47H-4z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol